import React from 'react';
import InfoButton from 'components/InfoButton';
import Tooltip from 'components/Tooltip';
import localeUtils from 'utils/LanguageLocale';
import { wrapFunctionalComponent } from 'utils/framework';
import { space } from 'style/config';
import { colors } from 'style/config';
import NonIncentivizedTooltipEN from 'components/ProductPage/RatingsAndReviews/ReviewsFilters/NonIncentivizedTooltip/locales/NonIncentivizedTooltip_en_US';
import NonIncentivizedTooltipFR from 'components/ProductPage/RatingsAndReviews/ReviewsFilters/NonIncentivizedTooltip/locales/NonIncentivizedTooltip_fr_CA';

const getText = localeUtils.getLocalisedDataFromResource(NonIncentivizedTooltipEN, NonIncentivizedTooltipFR);

const NonIncentivizedTooltip = ({ isActive }) => (
    <Tooltip
        isFixed={true}
        sideOffset={-space[1]}
        content={getText('nonIncentivized')}
        fontSize='sm'
    >
        <InfoButton
            marginLeft={-1}
            color={isActive ? colors.white : null}
            hoverColor={isActive ? colors.midGray : null}
            aria-label={getText('moreInfo')}
        />
    </Tooltip>
);

export default wrapFunctionalComponent(NonIncentivizedTooltip, 'NonIncentivizedTooltip');
